import * as React from 'react';
import { TooltipHost, ICalloutProps, ITooltipHostStyles } from 'office-ui-fabric-react';

export const getTooltipCalloutProps = (): ICalloutProps => {
    const calloutProps: ICalloutProps = {
        styles: {
            root: {
                padding: '16px 16px 16px 16px'
            }
        },
        calloutMaxWidth: 300
    };

    return calloutProps;
};

export function AddTooltipToElement(element: JSX.Element, tooltip: string, tooltipHostStyles?: ITooltipHostStyles): JSX.Element {
    return (
        <TooltipHost styles={tooltipHostStyles} calloutProps={getTooltipCalloutProps()} content={tooltip}>
            {element}
        </TooltipHost>
    );
}
